import React from "react";
import Button from "./button";

interface PrimaryButtonProps extends React.PropsWithChildren {
    className?: string;
    onClick?: () => void;
    isDisabled?: boolean;
    textStyle?: string;
    form?: string;
    type?: "button" | "submit";
    testid?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    children,
    onClick,
    className = "",
    isDisabled = false,
    textStyle = "",
    type = "button",
    form,
    testid = ""
}) => {
    return (
        <Button
            type={type}
            onClick={onClick}
            isDisabled={isDisabled}
            form={form}
            textStyle={`whitespace-nowrap text-button-text font-medium text-white ${textStyle}`}
            className={`
        group
        overflow-hidden
        ${isDisabled ? "bg-gray" : "bg-button-accent-color"}
        transition-all
        duration-300
        focus:bg-dark-blu
        enabled:hover:bg-dark-blu
        disabled:bg-Stroke-color
        ${className}
      `}
            children={children}
            testid={testid}
        />
    );
};

export default PrimaryButton;
